/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.RatingsControlPanel {

    interface ICollapseTextDirectiveAttrs {
        meevoCollapseText: string;
        meevoCollapseTextGroup: string;
        meevoCollapseTextIsOpen?: boolean;
    }

    const COLLAPSE_TEXT_EVENT = 'collapseTextInCollapseTextDirective';
    const DEFAULT_VISIBLE_CHARACTERS = 256;

    export class CollapseTextDirective implements angular.IDirective {

        public restrict = 'A';
        public scope = {
            meevoCollapseText: '=',
            meevoCollapseTextGroup: '@',
            meevoCollapseTextCharacters: '=?',
            meevoCollapseTextIsOpen: '=?',
        };

        static factory(): angular.IDirectiveFactory {
            const directive = ($compile, $rootScope) => {
                return new CollapseTextDirective($compile, $rootScope);
            };

            directive.$inject = ['$compile', '$rootScope'];

            return directive;
        }

        constructor(
            private $compile: ng.ICompileService,
            private $rootScope: ng.IRootScopeService
        ) {}

        link($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ICollapseTextDirectiveAttrs) {
            $scope.open = $scope.meevoCollapseTextIsOpen !== undefined ? $scope.meevoCollapseTextIsOpen : false;
            $scope.visibleCharacters = $scope.meevoCollapseTextCharacters !== undefined ? +$scope.meevoCollapseTextCharacters : DEFAULT_VISIBLE_CHARACTERS;

            $scope.$on(COLLAPSE_TEXT_EVENT, (ev, groupName) => {
                if (groupName === $scope.meevoCollapseTextGroup) {
                    $scope.open = false;
                }
            });

            $scope.toggleShow = () => {
                if (!$scope.open) {
                    this.$rootScope.$broadcast(COLLAPSE_TEXT_EVENT, $scope.meevoCollapseTextGroup);
                }
                $scope.open = !$scope.open;
            };

            $scope.$watch('meevoCollapseText', () => {
                $element.empty();

                let el = angular.element(`<span>
                    {{open ? meevoCollapseText : meevoCollapseText.slice(0, visibleCharacters)}}
                    <a ng-if="meevoCollapseText.length > visibleCharacters" href="#" ng-click='toggleShow()'>{{(open ? 'LABEL_SHOW_LESS' : 'LABEL_SHOW_MORE')|translate}}</a>
                 </span>`);

                $element.append(this.$compile(el)($scope));
            });
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .directive('meevoCollapseText', CollapseTextDirective.factory());
}
